import Component from '../core/Component'
import EventBus from '../core/EventBus'
import Scroll from '../services/Scroll'
import enquire from 'enquire.js'
import { queries } from '../core/config'

const STATES = {
    ACTIVE: 'is-active',
    PINNED: 'is-pinned'
}

const defaults = {
    static: false
}

export default class NavOpener extends Component {
    constructor(element) {
        super(element)

        this.isPinned = false
        this.isMobile = false
        this.isOpen = false

        this.enquireHandler = {
            match: () => {
                this.isMobile = true
            },
            unmatch: () => {
                this.isMobile = false
            }
        }
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)
        EventBus.on('mobilenav:open', this.handleOpen)
        EventBus.on('mobilenav:close', this.handleClose)

        if (!this.options.static) {
            Scroll.on('scroll', this.handleScroll)
        }

        enquire.register(queries.smallMax, this.enquireHandler)
    }

    destroy() {
        enquire.unregister(queries.smallMax, this.enquireHandler)
        EventBus.off('mobilenav:open', this.handleOpen)
        EventBus.off('mobilenav:close', this.handleClose)
        Scroll.off('scroll', this.handleScroll)
    }

    handleScroll = ({ offset }) => {

        if (this.isOpen) {
            return
        }

        if (offset.y > 400 && !this.isPinned) {
            this.isPinned = true
            this.element.classList.add(STATES.PINNED)

            if (!this.isMobile) {
                EventBus.emit('navtoggle:pinchange', {
                    status: 1
                })
            }
        }

        if (offset.y < 400 && this.isPinned) {
            this.isPinned = false
            this.element.classList.remove(STATES.PINNED)

            if (!this.isMobile) {
                EventBus.emit('navtoggle:pinchange', {
                    status: 0
                })
            }
        }
    }

    handleOpen = () => {
        this.isOpen = true
        this.element.classList.add(STATES.ACTIVE)
    }

    handleClose = () => {
        this.isOpen = false
        this.element.classList.remove(STATES.ACTIVE)
    }

    handleClick = event => {
        event.preventDefault()
        event.stopPropagation()
        Component.getFromElement('mobile-nav')?.toggle()
    }
}
